/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Project.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Project } from "./Project";

import { Activity } from "./Activity";
import { ActivityApiAsyncImport } from "./ActivityApiAsyncImport";
import { ApiKey } from "./ApiKey";
import { Area } from "./Area";
import { Audit } from "./Audit";
import { CalendarEvent } from "./CalendarEvent";
import { CalendarEventResource } from "./CalendarEventResource";
import { CommandCenterView } from "./CommandCenterView";
import { Delivery } from "./Delivery";
import { DeliveryFilter } from "./DeliveryFilter";
import { Equipment } from "./Equipment";
import { ExecutiveCommandSection } from "./ExecutiveCommandSection";
import { Geotiff } from "./Geotiff";
import { IntegrationDetail } from "./IntegrationDetail";
import { MapLayer } from "./MapLayer";
import { MapObject } from "./MapObject";
import { Material } from "./Material";
import { Message } from "./Message";
import { NotificationList } from "./NotificationList";
import { Order } from "./Order";
import { OrderExport } from "./OrderExport";
import { Permission } from "./Permission";
import { ProcurementFilter } from "./ProcurementFilter";
import { ProcurementView } from "./ProcurementView";
import { ProjectsWeatherAlert } from "./ProjectsWeatherAlert";
import { RecipientList } from "./RecipientList";
import { RepeatingCalendarEventDefinition } from "./RepeatingCalendarEventDefinition";
import { ScheduledReport } from "./ScheduledReport";
import { Submittal } from "./Submittal";
import { Team } from "./Team";
import { Value } from "./Value";
import { VendorLink } from "./VendorLink";

export type activitiesIntegrationSource =
    | "procore"
    | "procore_sandbox"
    | "autodesk_construction"
    | "primavera_p6"
    | "microsoft_project"
    | "faker"
    | "api_upload"
    | "unset";
export type integrationSource = "unset" | "procore" | "procore_sandbox" | "autodesk_construction";
export type leadTimesDefaultActivityDependency = "start" | "finish";
export type leadTimesDefaultLeadTimeUnitType = "days" | "weeks" | "months" | "years";
export type leadTimesDefaultOrderDelayUnitType = "days" | "weeks" | "months" | "years";
export type leadTimesDefaultReviewDurationUnitType = "days" | "weeks" | "months" | "years";
export type submittalsIntegrationSource = "procore" | "procore_sandbox" | "autodesk_construction" | "faker" | "unset";
export type weatherProvider = "nws" | "perry";

export const activitiesIntegrationSourceValues = {
    procore: 1,
    procore_sandbox: 2,
    autodesk_construction: 3,
    primavera_p6: 5,
    microsoft_project: 6,
    faker: 8,
    api_upload: 9,
    unset: 10,
};
export const integrationSourceValues = { unset: 0, procore: 1, procore_sandbox: 2, autodesk_construction: 3 };
export const leadTimesDefaultActivityDependencyValues = { start: 0, finish: 1 };
export const leadTimesDefaultLeadTimeUnitTypeValues = { days: 0, weeks: 1, months: 2, years: 3 };
export const leadTimesDefaultOrderDelayUnitTypeValues = { days: 0, weeks: 1, months: 2, years: 3 };
export const leadTimesDefaultReviewDurationUnitTypeValues = { days: 0, weeks: 1, months: 2, years: 3 };
export const submittalsIntegrationSourceValues = {
    procore: 1,
    procore_sandbox: 2,
    autodesk_construction: 3,
    faker: 8,
    unset: 10,
};
export const weatherProviderValues = { nws: 0, perry: 1 };

export abstract class ProjectModel {
    id: number;
    actionItemsEmailDay: number | null;
    actionItemsEmailTime: Dayjs | null;
    activitiesIntegrationSource: activitiesIntegrationSource;
    address1: string | null;
    address2: string | null;
    allowPublicCommandCenterUrls: boolean;
    archived: boolean | null;
    bannerEnabled: boolean;
    bannerText: string;
    buildCentralId: number | null;
    city: string | null;
    conflictCheckDeliveriesAreas: boolean;
    conflictCheckDeliveriesEquipment: boolean;
    conflictCheckDeliveriesTeams: boolean;
    conflictCheckIncludePending: boolean;
    conflictCheckInspectionsAreas: boolean;
    conflictCheckInspectionsEquipment: boolean;
    conflictCheckInspectionsTeams: boolean;
    conflictCheckWorkEventsAreas: boolean;
    conflictCheckWorkEventsEquipment: boolean;
    conflictCheckWorkEventsTeams: boolean;
    contactsList: string | null;
    createdAt: Dayjs;
    deliveryApprovalRequireFinal: boolean;
    deliveryApprovalRequireGc: boolean | null;
    deliveryCreatedApprovalRequireTeams: boolean | null;
    deliveryLogging: boolean | null;
    deliveryScheduledApprovalRequireTeams: boolean | null;
    detail: string;
    dronedeployIntegrationKey: string | null;
    enableLightningAlerts: boolean | null;
    enableVendorScheduling: boolean | null;
    enableWeatherSevere: boolean | null;
    enableWeatherThreats: boolean | null;
    gcCanApproveTradeDeliveries: boolean | null;
    inspectionApprovalRequireFinal: boolean;
    integrationAccessInfo: any | null;
    integrationDailyLogDeliveries: boolean | null;
    integrationImportMembers: boolean | null;
    integrationInfo: any;
    integrationLastSyncedActivities: Dayjs | null;
    integrationLastSyncedSubmittals: Dayjs | null;
    integrationSource: integrationSource;
    integrationSourceCompanyId: string | null;
    integrationSourceCompanyName: string | null;
    integrationSourceIdentifiedGcCompanyId: string | null;
    integrationSourceProjectId: string | null;
    integrationSourceProjectName: string | null;
    integrationSubmittalsDeliveries: boolean | null;
    integrationSyncFailures: number;
    integrationUserUploadActivitiesFilename: string | null;
    jobsiteAlertDisplayTime: number;
    jobsiteCommandInterval: number;
    languageConfig: any;
    lastLightningStrike: Dayjs | null;
    lat: number;
    latOverride: number | null;
    leadTimesApproveResponses: string[] | null;
    leadTimesAutomaticReplaceRevisions: boolean;
    leadTimesAutomaticSyncMaterialDates: boolean;
    leadTimesDefaultActivityDependency: leadTimesDefaultActivityDependency;
    leadTimesDefaultCheckInFrequency: number | null;
    leadTimesDefaultLeadTime: number | null;
    leadTimesDefaultLeadTimeUnitType: leadTimesDefaultLeadTimeUnitType;
    leadTimesDefaultOrderDelayUnitType: leadTimesDefaultOrderDelayUnitType;
    leadTimesDefaultReviewCycleModifier: number;
    leadTimesDefaultReviewDurationUnitType: leadTimesDefaultReviewDurationUnitType;
    leadTimesDefaultShakeoutDays: number | null;
    leadTimesOrderDelay: number | null;
    leadTimesRequiredOnJobsiteRequireGc: boolean | null;
    leadTimesReviewDuration: number | null;
    leadTimesReviseAndResubmitResponses: string[] | null;
    leadTimesSubmitResponses: string[] | null;
    leadTimesValidApproveStatuses: string[] | null;
    leadTimesValidReviseAndResubmitStatuses: string[] | null;
    leadTimesValidSubmitStatuses: string[] | null;
    lightningAlertDistance: number | null;
    lightningAlertsChannel: number | null;
    lightningAllClear: boolean | null;
    lightningAllClearDuration: number | null;
    listed: boolean | null;
    lon: number;
    lonOverride: number | null;
    mapLat: number | null;
    mapLon: number | null;
    mapStyle: string | null;
    mapZoom: number;
    maxDeliverySchedule: number | null;
    minDeliverySchedule: number | null;
    notificationListsAreas: boolean;
    notificationListsEquipments: boolean;
    notificationListsTeams: boolean;
    overviewEmailDay: number | null;
    overviewEmailTime: Dayjs | null;
    owningTeamId: number | null;
    ppeRequired: string[];
    procurementSyncTime: Dayjs | null;
    projectHasBeenModified: boolean | null;
    projectName: string | null;
    requireVendorAddress: boolean;
    requireVendorInfoDeliveries: boolean | null;
    shareDeliveryVehicle: boolean | null;
    shareEta: boolean | null;
    state: string | null;
    submittalStatistics: any | null;
    submittalsIntegrationSource: submittalsIntegrationSource;
    timezone: string;
    uniqueToken: string | null;
    updatedAt: Dayjs;
    useAdvancedDeliveryLogic: boolean | null;
    useAdvancedDeliveryLogicEquipment: boolean | null;
    useAdvancedDeliveryLogicExceptionDays: boolean | null;
    useAdvancedDeliveryLogicMapMarker: boolean | null;
    useAdvancedDeliveryLogicPending: boolean;
    useAdvancedDeliveryLogicTeams: boolean | null;
    useDeliveries: boolean;
    useLeadTimes: boolean;
    useOverride: boolean | null;
    weatherProvider: weatherProvider;
    weatherProviderConfig: any;
    weatherSevereChannel: number | null;
    weatherThreatsChannel: number | null;
    workEventApprovalRequireFinal: boolean;
    zipCode: string | null;
    dronedeployApiConfigured: boolean | null;
    activities: Activity[] | undefined;
    activityApiAsyncImports: ActivityApiAsyncImport[] | undefined;
    apiKeys: ApiKey[] | undefined;
    areas: Area[] | undefined;
    audits: Audit[] | undefined;
    calendarEventResources: CalendarEventResource[] | undefined;
    calendarEvents: CalendarEvent[] | undefined;
    commandCenterViews: CommandCenterView[] | undefined;
    deliveries: Delivery[] | undefined;
    deliveryFilters: DeliveryFilter[] | undefined;
    equipment: Equipment[] | undefined;
    executiveCommandSections: ExecutiveCommandSection[] | undefined;
    geotiff: Geotiff | null | undefined;
    integrationDetail: IntegrationDetail | null | undefined;
    mapLayers: MapLayer[] | undefined;
    mapObjects: MapObject[] | undefined;
    materials: Material[] | undefined;
    messages: Message[] | undefined;
    notificationLists: NotificationList[] | undefined;
    orderExports: OrderExport[] | undefined;
    orders: Order[] | undefined;
    owningTeam: Team | null | undefined;
    permissions: Permission[] | undefined;
    procurementFilters: ProcurementFilter[] | undefined;
    procurementViews: ProcurementView[] | undefined;
    projectsWeatherAlerts: ProjectsWeatherAlert[] | undefined;
    recipientLists: RecipientList[] | undefined;
    repeatingCalendarEventDefinitions: RepeatingCalendarEventDefinition[] | undefined;
    scheduledReports: ScheduledReport[] | undefined;
    submittals: Submittal[] | undefined;
    values: Value[] | undefined;
    vendorLinks: VendorLink[] | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        actionItemsEmailDay: number | null,
        actionItemsEmailTime: Dayjs | null,
        activitiesIntegrationSource: activitiesIntegrationSource,
        address1: string | null,
        address2: string | null,
        allowPublicCommandCenterUrls: boolean,
        archived: boolean | null,
        bannerEnabled: boolean,
        bannerText: string,
        buildCentralId: number | null,
        city: string | null,
        conflictCheckDeliveriesAreas: boolean,
        conflictCheckDeliveriesEquipment: boolean,
        conflictCheckDeliveriesTeams: boolean,
        conflictCheckIncludePending: boolean,
        conflictCheckInspectionsAreas: boolean,
        conflictCheckInspectionsEquipment: boolean,
        conflictCheckInspectionsTeams: boolean,
        conflictCheckWorkEventsAreas: boolean,
        conflictCheckWorkEventsEquipment: boolean,
        conflictCheckWorkEventsTeams: boolean,
        contactsList: string | null,
        createdAt: Dayjs,
        deliveryApprovalRequireFinal: boolean,
        deliveryApprovalRequireGc: boolean | null,
        deliveryCreatedApprovalRequireTeams: boolean | null,
        deliveryLogging: boolean | null,
        deliveryScheduledApprovalRequireTeams: boolean | null,
        detail: string,
        dronedeployIntegrationKey: string | null,
        enableLightningAlerts: boolean | null,
        enableVendorScheduling: boolean | null,
        enableWeatherSevere: boolean | null,
        enableWeatherThreats: boolean | null,
        gcCanApproveTradeDeliveries: boolean | null,
        inspectionApprovalRequireFinal: boolean,
        integrationAccessInfo: any | null,
        integrationDailyLogDeliveries: boolean | null,
        integrationImportMembers: boolean | null,
        integrationInfo: any,
        integrationLastSyncedActivities: Dayjs | null,
        integrationLastSyncedSubmittals: Dayjs | null,
        integrationSource: integrationSource,
        integrationSourceCompanyId: string | null,
        integrationSourceCompanyName: string | null,
        integrationSourceIdentifiedGcCompanyId: string | null,
        integrationSourceProjectId: string | null,
        integrationSourceProjectName: string | null,
        integrationSubmittalsDeliveries: boolean | null,
        integrationSyncFailures: number,
        integrationUserUploadActivitiesFilename: string | null,
        jobsiteAlertDisplayTime: number,
        jobsiteCommandInterval: number,
        languageConfig: any,
        lastLightningStrike: Dayjs | null,
        lat: number,
        latOverride: number | null,
        leadTimesApproveResponses: string[] | null,
        leadTimesAutomaticReplaceRevisions: boolean,
        leadTimesAutomaticSyncMaterialDates: boolean,
        leadTimesDefaultActivityDependency: leadTimesDefaultActivityDependency,
        leadTimesDefaultCheckInFrequency: number | null,
        leadTimesDefaultLeadTime: number | null,
        leadTimesDefaultLeadTimeUnitType: leadTimesDefaultLeadTimeUnitType,
        leadTimesDefaultOrderDelayUnitType: leadTimesDefaultOrderDelayUnitType,
        leadTimesDefaultReviewCycleModifier: number,
        leadTimesDefaultReviewDurationUnitType: leadTimesDefaultReviewDurationUnitType,
        leadTimesDefaultShakeoutDays: number | null,
        leadTimesOrderDelay: number | null,
        leadTimesRequiredOnJobsiteRequireGc: boolean | null,
        leadTimesReviewDuration: number | null,
        leadTimesReviseAndResubmitResponses: string[] | null,
        leadTimesSubmitResponses: string[] | null,
        leadTimesValidApproveStatuses: string[] | null,
        leadTimesValidReviseAndResubmitStatuses: string[] | null,
        leadTimesValidSubmitStatuses: string[] | null,
        lightningAlertDistance: number | null,
        lightningAlertsChannel: number | null,
        lightningAllClear: boolean | null,
        lightningAllClearDuration: number | null,
        listed: boolean | null,
        lon: number,
        lonOverride: number | null,
        mapLat: number | null,
        mapLon: number | null,
        mapStyle: string | null,
        mapZoom: number,
        maxDeliverySchedule: number | null,
        minDeliverySchedule: number | null,
        notificationListsAreas: boolean,
        notificationListsEquipments: boolean,
        notificationListsTeams: boolean,
        overviewEmailDay: number | null,
        overviewEmailTime: Dayjs | null,
        owningTeamId: number | null,
        ppeRequired: string[],
        procurementSyncTime: Dayjs | null,
        projectHasBeenModified: boolean | null,
        projectName: string | null,
        requireVendorAddress: boolean,
        requireVendorInfoDeliveries: boolean | null,
        shareDeliveryVehicle: boolean | null,
        shareEta: boolean | null,
        state: string | null,
        submittalStatistics: any | null,
        submittalsIntegrationSource: submittalsIntegrationSource,
        timezone: string,
        uniqueToken: string | null,
        updatedAt: Dayjs,
        useAdvancedDeliveryLogic: boolean | null,
        useAdvancedDeliveryLogicEquipment: boolean | null,
        useAdvancedDeliveryLogicExceptionDays: boolean | null,
        useAdvancedDeliveryLogicMapMarker: boolean | null,
        useAdvancedDeliveryLogicPending: boolean,
        useAdvancedDeliveryLogicTeams: boolean | null,
        useDeliveries: boolean,
        useLeadTimes: boolean,
        useOverride: boolean | null,
        weatherProvider: weatherProvider,
        weatherProviderConfig: any,
        weatherSevereChannel: number | null,
        weatherThreatsChannel: number | null,
        workEventApprovalRequireFinal: boolean,
        zipCode: string | null,
        dronedeployApiConfigured: boolean | null,
        activities: Activity[] | undefined,
        activityApiAsyncImports: ActivityApiAsyncImport[] | undefined,
        apiKeys: ApiKey[] | undefined,
        areas: Area[] | undefined,
        audits: Audit[] | undefined,
        calendarEventResources: CalendarEventResource[] | undefined,
        calendarEvents: CalendarEvent[] | undefined,
        commandCenterViews: CommandCenterView[] | undefined,
        deliveries: Delivery[] | undefined,
        deliveryFilters: DeliveryFilter[] | undefined,
        equipment: Equipment[] | undefined,
        executiveCommandSections: ExecutiveCommandSection[] | undefined,
        geotiff: Geotiff | null | undefined,
        integrationDetail: IntegrationDetail | null | undefined,
        mapLayers: MapLayer[] | undefined,
        mapObjects: MapObject[] | undefined,
        materials: Material[] | undefined,
        messages: Message[] | undefined,
        notificationLists: NotificationList[] | undefined,
        orderExports: OrderExport[] | undefined,
        orders: Order[] | undefined,
        owningTeam: Team | null | undefined,
        permissions: Permission[] | undefined,
        procurementFilters: ProcurementFilter[] | undefined,
        procurementViews: ProcurementView[] | undefined,
        projectsWeatherAlerts: ProjectsWeatherAlert[] | undefined,
        recipientLists: RecipientList[] | undefined,
        repeatingCalendarEventDefinitions: RepeatingCalendarEventDefinition[] | undefined,
        scheduledReports: ScheduledReport[] | undefined,
        submittals: Submittal[] | undefined,
        values: Value[] | undefined,
        vendorLinks: VendorLink[] | undefined
    ) {
        this.id = id;
        this.actionItemsEmailDay = actionItemsEmailDay;
        this.actionItemsEmailTime = actionItemsEmailTime;
        this.activitiesIntegrationSource = activitiesIntegrationSource;
        this.address1 = address1;
        this.address2 = address2;
        this.allowPublicCommandCenterUrls = allowPublicCommandCenterUrls;
        this.archived = archived;
        this.bannerEnabled = bannerEnabled;
        this.bannerText = bannerText;
        this.buildCentralId = buildCentralId;
        this.city = city;
        this.conflictCheckDeliveriesAreas = conflictCheckDeliveriesAreas;
        this.conflictCheckDeliveriesEquipment = conflictCheckDeliveriesEquipment;
        this.conflictCheckDeliveriesTeams = conflictCheckDeliveriesTeams;
        this.conflictCheckIncludePending = conflictCheckIncludePending;
        this.conflictCheckInspectionsAreas = conflictCheckInspectionsAreas;
        this.conflictCheckInspectionsEquipment = conflictCheckInspectionsEquipment;
        this.conflictCheckInspectionsTeams = conflictCheckInspectionsTeams;
        this.conflictCheckWorkEventsAreas = conflictCheckWorkEventsAreas;
        this.conflictCheckWorkEventsEquipment = conflictCheckWorkEventsEquipment;
        this.conflictCheckWorkEventsTeams = conflictCheckWorkEventsTeams;
        this.contactsList = contactsList;
        this.createdAt = createdAt;
        this.deliveryApprovalRequireFinal = deliveryApprovalRequireFinal;
        this.deliveryApprovalRequireGc = deliveryApprovalRequireGc;
        this.deliveryCreatedApprovalRequireTeams = deliveryCreatedApprovalRequireTeams;
        this.deliveryLogging = deliveryLogging;
        this.deliveryScheduledApprovalRequireTeams = deliveryScheduledApprovalRequireTeams;
        this.detail = detail;
        this.dronedeployIntegrationKey = dronedeployIntegrationKey;
        this.enableLightningAlerts = enableLightningAlerts;
        this.enableVendorScheduling = enableVendorScheduling;
        this.enableWeatherSevere = enableWeatherSevere;
        this.enableWeatherThreats = enableWeatherThreats;
        this.gcCanApproveTradeDeliveries = gcCanApproveTradeDeliveries;
        this.inspectionApprovalRequireFinal = inspectionApprovalRequireFinal;
        this.integrationAccessInfo = integrationAccessInfo;
        this.integrationDailyLogDeliveries = integrationDailyLogDeliveries;
        this.integrationImportMembers = integrationImportMembers;
        this.integrationInfo = integrationInfo;
        this.integrationLastSyncedActivities = integrationLastSyncedActivities;
        this.integrationLastSyncedSubmittals = integrationLastSyncedSubmittals;
        this.integrationSource = integrationSource;
        this.integrationSourceCompanyId = integrationSourceCompanyId;
        this.integrationSourceCompanyName = integrationSourceCompanyName;
        this.integrationSourceIdentifiedGcCompanyId = integrationSourceIdentifiedGcCompanyId;
        this.integrationSourceProjectId = integrationSourceProjectId;
        this.integrationSourceProjectName = integrationSourceProjectName;
        this.integrationSubmittalsDeliveries = integrationSubmittalsDeliveries;
        this.integrationSyncFailures = integrationSyncFailures;
        this.integrationUserUploadActivitiesFilename = integrationUserUploadActivitiesFilename;
        this.jobsiteAlertDisplayTime = jobsiteAlertDisplayTime;
        this.jobsiteCommandInterval = jobsiteCommandInterval;
        this.languageConfig = languageConfig;
        this.lastLightningStrike = lastLightningStrike;
        this.lat = lat;
        this.latOverride = latOverride;
        this.leadTimesApproveResponses = leadTimesApproveResponses;
        this.leadTimesAutomaticReplaceRevisions = leadTimesAutomaticReplaceRevisions;
        this.leadTimesAutomaticSyncMaterialDates = leadTimesAutomaticSyncMaterialDates;
        this.leadTimesDefaultActivityDependency = leadTimesDefaultActivityDependency;
        this.leadTimesDefaultCheckInFrequency = leadTimesDefaultCheckInFrequency;
        this.leadTimesDefaultLeadTime = leadTimesDefaultLeadTime;
        this.leadTimesDefaultLeadTimeUnitType = leadTimesDefaultLeadTimeUnitType;
        this.leadTimesDefaultOrderDelayUnitType = leadTimesDefaultOrderDelayUnitType;
        this.leadTimesDefaultReviewCycleModifier = leadTimesDefaultReviewCycleModifier;
        this.leadTimesDefaultReviewDurationUnitType = leadTimesDefaultReviewDurationUnitType;
        this.leadTimesDefaultShakeoutDays = leadTimesDefaultShakeoutDays;
        this.leadTimesOrderDelay = leadTimesOrderDelay;
        this.leadTimesRequiredOnJobsiteRequireGc = leadTimesRequiredOnJobsiteRequireGc;
        this.leadTimesReviewDuration = leadTimesReviewDuration;
        this.leadTimesReviseAndResubmitResponses = leadTimesReviseAndResubmitResponses;
        this.leadTimesSubmitResponses = leadTimesSubmitResponses;
        this.leadTimesValidApproveStatuses = leadTimesValidApproveStatuses;
        this.leadTimesValidReviseAndResubmitStatuses = leadTimesValidReviseAndResubmitStatuses;
        this.leadTimesValidSubmitStatuses = leadTimesValidSubmitStatuses;
        this.lightningAlertDistance = lightningAlertDistance;
        this.lightningAlertsChannel = lightningAlertsChannel;
        this.lightningAllClear = lightningAllClear;
        this.lightningAllClearDuration = lightningAllClearDuration;
        this.listed = listed;
        this.lon = lon;
        this.lonOverride = lonOverride;
        this.mapLat = mapLat;
        this.mapLon = mapLon;
        this.mapStyle = mapStyle;
        this.mapZoom = mapZoom;
        this.maxDeliverySchedule = maxDeliverySchedule;
        this.minDeliverySchedule = minDeliverySchedule;
        this.notificationListsAreas = notificationListsAreas;
        this.notificationListsEquipments = notificationListsEquipments;
        this.notificationListsTeams = notificationListsTeams;
        this.overviewEmailDay = overviewEmailDay;
        this.overviewEmailTime = overviewEmailTime;
        this.owningTeamId = owningTeamId;
        this.ppeRequired = ppeRequired;
        this.procurementSyncTime = procurementSyncTime;
        this.projectHasBeenModified = projectHasBeenModified;
        this.projectName = projectName;
        this.requireVendorAddress = requireVendorAddress;
        this.requireVendorInfoDeliveries = requireVendorInfoDeliveries;
        this.shareDeliveryVehicle = shareDeliveryVehicle;
        this.shareEta = shareEta;
        this.state = state;
        this.submittalStatistics = submittalStatistics;
        this.submittalsIntegrationSource = submittalsIntegrationSource;
        this.timezone = timezone;
        this.uniqueToken = uniqueToken;
        this.updatedAt = updatedAt;
        this.useAdvancedDeliveryLogic = useAdvancedDeliveryLogic;
        this.useAdvancedDeliveryLogicEquipment = useAdvancedDeliveryLogicEquipment;
        this.useAdvancedDeliveryLogicExceptionDays = useAdvancedDeliveryLogicExceptionDays;
        this.useAdvancedDeliveryLogicMapMarker = useAdvancedDeliveryLogicMapMarker;
        this.useAdvancedDeliveryLogicPending = useAdvancedDeliveryLogicPending;
        this.useAdvancedDeliveryLogicTeams = useAdvancedDeliveryLogicTeams;
        this.useDeliveries = useDeliveries;
        this.useLeadTimes = useLeadTimes;
        this.useOverride = useOverride;
        this.weatherProvider = weatherProvider;
        this.weatherProviderConfig = weatherProviderConfig;
        this.weatherSevereChannel = weatherSevereChannel;
        this.weatherThreatsChannel = weatherThreatsChannel;
        this.workEventApprovalRequireFinal = workEventApprovalRequireFinal;
        this.zipCode = zipCode;
        this.dronedeployApiConfigured = dronedeployApiConfigured;
        this.activities = activities;
        this.activityApiAsyncImports = activityApiAsyncImports;
        this.apiKeys = apiKeys;
        this.areas = areas;
        this.audits = audits;
        this.calendarEventResources = calendarEventResources;
        this.calendarEvents = calendarEvents;
        this.commandCenterViews = commandCenterViews;
        this.deliveries = deliveries;
        this.deliveryFilters = deliveryFilters;
        this.equipment = equipment;
        this.executiveCommandSections = executiveCommandSections;
        this.geotiff = geotiff;
        this.integrationDetail = integrationDetail;
        this.mapLayers = mapLayers;
        this.mapObjects = mapObjects;
        this.materials = materials;
        this.messages = messages;
        this.notificationLists = notificationLists;
        this.orderExports = orderExports;
        this.orders = orders;
        this.owningTeam = owningTeam;
        this.permissions = permissions;
        this.procurementFilters = procurementFilters;
        this.procurementViews = procurementViews;
        this.projectsWeatherAlerts = projectsWeatherAlerts;
        this.recipientLists = recipientLists;
        this.repeatingCalendarEventDefinitions = repeatingCalendarEventDefinitions;
        this.scheduledReports = scheduledReports;
        this.submittals = submittals;
        this.values = values;
        this.vendorLinks = vendorLinks;
    }
    /* eslint-enable max-statements */

    // eslint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Project {
        const newObject = new Project(
            json["id"],
            json["action_items_email_day"],
            json["action_items_email_time"] ? dayjs(json["action_items_email_time"]).tz(timezone) : null,
            json["activities_integration_source"],
            json["address_1"],
            json["address_2"],
            json["allow_public_command_center_urls"],
            json["archived"],
            json["banner_enabled"],
            json["banner_text"],
            json["build_central_id"],
            json["city"],
            json["conflict_check_deliveries_areas"],
            json["conflict_check_deliveries_equipment"],
            json["conflict_check_deliveries_teams"],
            json["conflict_check_include_pending"],
            json["conflict_check_inspections_areas"],
            json["conflict_check_inspections_equipment"],
            json["conflict_check_inspections_teams"],
            json["conflict_check_work_events_areas"],
            json["conflict_check_work_events_equipment"],
            json["conflict_check_work_events_teams"],
            json["contacts_list"],
            dayjs(json["created_at"]).tz(timezone),
            json["delivery_approval_require_final"],
            json["delivery_approval_require_gc"],
            json["delivery_created_approval_require_teams"],
            json["delivery_logging"],
            json["delivery_scheduled_approval_require_teams"],
            json["detail"],
            json["dronedeploy_integration_key"],
            json["enable_lightning_alerts"],
            json["enable_vendor_scheduling"],
            json["enable_weather_severe"],
            json["enable_weather_threats"],
            json["gc_can_approve_trade_deliveries"],
            json["inspection_approval_require_final"],
            json["integration_access_info"],
            json["integration_daily_log_deliveries"],
            json["integration_import_members"],
            json["integration_info"],
            json["integration_last_synced_activities"]
                ? dayjs(json["integration_last_synced_activities"]).tz(timezone)
                : null,
            json["integration_last_synced_submittals"]
                ? dayjs(json["integration_last_synced_submittals"]).tz(timezone)
                : null,
            json["integration_source"],
            json["integration_source_company_id"],
            json["integration_source_company_name"],
            json["integration_source_identified_gc_company_id"],
            json["integration_source_project_id"],
            json["integration_source_project_name"],
            json["integration_submittals_deliveries"],
            json["integration_sync_failures"],
            json["integration_user_upload_activities_filename"],
            json["jobsite_alert_display_time"],
            json["jobsite_command_interval"],
            json["language_config"],
            json["last_lightning_strike"] ? dayjs(json["last_lightning_strike"]).tz(timezone) : null,
            json["lat"],
            json["lat_override"],
            json["lead_times_approve_responses"],
            json["lead_times_automatic_replace_revisions"],
            json["lead_times_automatic_sync_material_dates"],
            json["lead_times_default_activity_dependency"],
            json["lead_times_default_check_in_frequency"],
            json["lead_times_default_lead_time"],
            json["lead_times_default_lead_time_unit_type"],
            json["lead_times_default_order_delay_unit_type"],
            json["lead_times_default_review_cycle_modifier"],
            json["lead_times_default_review_duration_unit_type"],
            json["lead_times_default_shakeout_days"],
            json["lead_times_order_delay"],
            json["lead_times_required_on_jobsite_require_gc"],
            json["lead_times_review_duration"],
            json["lead_times_revise_and_resubmit_responses"],
            json["lead_times_submit_responses"],
            json["lead_times_valid_approve_statuses"],
            json["lead_times_valid_revise_and_resubmit_statuses"],
            json["lead_times_valid_submit_statuses"],
            json["lightning_alert_distance"],
            json["lightning_alerts_channel"],
            json["lightning_all_clear"],
            json["lightning_all_clear_duration"],
            json["listed"],
            json["lon"],
            json["lon_override"],
            json["map_lat"],
            json["map_lon"],
            json["map_style"],
            json["map_zoom"],
            json["max_delivery_schedule"],
            json["min_delivery_schedule"],
            json["notification_lists_areas"],
            json["notification_lists_equipments"],
            json["notification_lists_teams"],
            json["overview_email_day"],
            json["overview_email_time"] ? dayjs(json["overview_email_time"]).tz(timezone) : null,
            json["owning_team_id"],
            json["ppe_required"],
            json["procurement_sync_time"] ? dayjs(json["procurement_sync_time"]).tz(timezone) : null,
            json["project_has_been_modified"],
            json["project_name"],
            json["require_vendor_address"],
            json["require_vendor_info_deliveries"],
            json["share_delivery_vehicle"],
            json["share_eta"],
            json["state"],
            json["submittal_statistics"],
            json["submittals_integration_source"],
            json["timezone"],
            json["unique_token"],
            dayjs(json["updated_at"]).tz(timezone),
            json["use_advanced_delivery_logic"],
            json["use_advanced_delivery_logic_equipment"],
            json["use_advanced_delivery_logic_exception_days"],
            json["use_advanced_delivery_logic_map_marker"],
            json["use_advanced_delivery_logic_pending"],
            json["use_advanced_delivery_logic_teams"],
            json["use_deliveries"],
            json["use_lead_times"],
            json["use_override"],
            json["weather_provider"],
            json["weather_provider_config"],
            json["weather_severe_channel"],
            json["weather_threats_channel"],
            json["work_event_approval_require_final"],
            json["zip_code"],
            json["dronedeploy_api_configured"],
            json["activities"]?.map((item: any) => Activity.fromApiObject(item, timezone)),
            json["activity_api_async_imports"]?.map((item: any) =>
                ActivityApiAsyncImport.fromApiObject(item, timezone)
            ),
            json["api_keys"]?.map((item: any) => ApiKey.fromApiObject(item, timezone)),
            json["areas"]?.map((item: any) => Area.fromApiObject(item, timezone)),
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["calendar_event_resources"]?.map((item: any) => CalendarEventResource.fromApiObject(item, timezone)),
            json["calendar_events"]?.map((item: any) => CalendarEvent.fromApiObject(item, timezone)),
            json["command_center_views"]?.map((item: any) => CommandCenterView.fromApiObject(item, timezone)),
            json["deliveries"]?.map((item: any) => Delivery.fromApiObject(item, timezone)),
            json["delivery_filters"]?.map((item: any) => DeliveryFilter.fromApiObject(item, timezone)),
            json["equipment"]?.map((item: any) => Equipment.fromApiObject(item, timezone)),
            json["executive_command_sections"]?.map((item: any) =>
                ExecutiveCommandSection.fromApiObject(item, timezone)
            ),
            json["geotiff"] == null ? json["geotiff"] : Geotiff.fromApiObject(json["geotiff"], timezone),
            json["integration_detail"] == null
                ? json["integration_detail"]
                : IntegrationDetail.fromApiObject(json["integration_detail"], timezone),
            json["map_layers"]?.map((item: any) => MapLayer.fromApiObject(item, timezone)),
            json["map_objects"]?.map((item: any) => MapObject.fromApiObject(item, timezone)),
            json["materials"]?.map((item: any) => Material.fromApiObject(item, timezone)),
            json["messages"]?.map((item: any) => Message.fromApiObject(item, timezone)),
            json["notification_lists"]?.map((item: any) => NotificationList.fromApiObject(item, timezone)),
            json["order_exports"]?.map((item: any) => OrderExport.fromApiObject(item, timezone)),
            json["orders"]?.map((item: any) => Order.fromApiObject(item, timezone)),
            json["owning_team"] == null ? json["owning_team"] : Team.fromApiObject(json["owning_team"], timezone),
            json["permissions"]?.map((item: any) => Permission.fromApiObject(item, timezone)),
            json["procurement_filters"]?.map((item: any) => ProcurementFilter.fromApiObject(item, timezone)),
            json["procurement_views"]?.map((item: any) => ProcurementView.fromApiObject(item, timezone)),
            json["projects_weather_alerts"]?.map((item: any) => ProjectsWeatherAlert.fromApiObject(item, timezone)),
            json["recipient_lists"]?.map((item: any) => RecipientList.fromApiObject(item, timezone)),
            json["repeating_calendar_event_definitions"]?.map((item: any) =>
                RepeatingCalendarEventDefinition.fromApiObject(item, timezone)
            ),
            json["scheduled_reports"]?.map((item: any) => ScheduledReport.fromApiObject(item, timezone)),
            json["submittals"]?.map((item: any) => Submittal.fromApiObject(item, timezone)),
            json["values"]?.map((item: any) => Value.fromApiObject(item, timezone)),
            json["vendor_links"]?.map((item: any) => VendorLink.fromApiObject(item, timezone))
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            action_items_email_day: this.actionItemsEmailDay,
            action_items_email_time: this.actionItemsEmailTime,
            activities_integration_source: this.activitiesIntegrationSource,
            address_1: this.address1,
            address_2: this.address2,
            allow_public_command_center_urls: this.allowPublicCommandCenterUrls,
            archived: this.archived,
            banner_enabled: this.bannerEnabled,
            banner_text: this.bannerText,
            build_central_id: this.buildCentralId,
            city: this.city,
            conflict_check_deliveries_areas: this.conflictCheckDeliveriesAreas,
            conflict_check_deliveries_equipment: this.conflictCheckDeliveriesEquipment,
            conflict_check_deliveries_teams: this.conflictCheckDeliveriesTeams,
            conflict_check_include_pending: this.conflictCheckIncludePending,
            conflict_check_inspections_areas: this.conflictCheckInspectionsAreas,
            conflict_check_inspections_equipment: this.conflictCheckInspectionsEquipment,
            conflict_check_inspections_teams: this.conflictCheckInspectionsTeams,
            conflict_check_work_events_areas: this.conflictCheckWorkEventsAreas,
            conflict_check_work_events_equipment: this.conflictCheckWorkEventsEquipment,
            conflict_check_work_events_teams: this.conflictCheckWorkEventsTeams,
            contacts_list: this.contactsList,
            created_at: this.createdAt,
            delivery_approval_require_final: this.deliveryApprovalRequireFinal,
            delivery_approval_require_gc: this.deliveryApprovalRequireGc,
            delivery_created_approval_require_teams: this.deliveryCreatedApprovalRequireTeams,
            delivery_logging: this.deliveryLogging,
            delivery_scheduled_approval_require_teams: this.deliveryScheduledApprovalRequireTeams,
            detail: this.detail,
            dronedeploy_integration_key: this.dronedeployIntegrationKey,
            enable_lightning_alerts: this.enableLightningAlerts,
            enable_vendor_scheduling: this.enableVendorScheduling,
            enable_weather_severe: this.enableWeatherSevere,
            enable_weather_threats: this.enableWeatherThreats,
            gc_can_approve_trade_deliveries: this.gcCanApproveTradeDeliveries,
            inspection_approval_require_final: this.inspectionApprovalRequireFinal,
            integration_access_info: this.integrationAccessInfo,
            integration_daily_log_deliveries: this.integrationDailyLogDeliveries,
            integration_import_members: this.integrationImportMembers,
            integration_info: this.integrationInfo,
            integration_last_synced_activities: this.integrationLastSyncedActivities,
            integration_last_synced_submittals: this.integrationLastSyncedSubmittals,
            integration_source: this.integrationSource,
            integration_source_company_id: this.integrationSourceCompanyId,
            integration_source_company_name: this.integrationSourceCompanyName,
            integration_source_identified_gc_company_id: this.integrationSourceIdentifiedGcCompanyId,
            integration_source_project_id: this.integrationSourceProjectId,
            integration_source_project_name: this.integrationSourceProjectName,
            integration_submittals_deliveries: this.integrationSubmittalsDeliveries,
            integration_sync_failures: this.integrationSyncFailures,
            integration_user_upload_activities_filename: this.integrationUserUploadActivitiesFilename,
            jobsite_alert_display_time: this.jobsiteAlertDisplayTime,
            jobsite_command_interval: this.jobsiteCommandInterval,
            language_config: this.languageConfig,
            last_lightning_strike: this.lastLightningStrike,
            lat: this.lat,
            lat_override: this.latOverride,
            lead_times_approve_responses: this.leadTimesApproveResponses,
            lead_times_automatic_replace_revisions: this.leadTimesAutomaticReplaceRevisions,
            lead_times_automatic_sync_material_dates: this.leadTimesAutomaticSyncMaterialDates,
            lead_times_default_activity_dependency: this.leadTimesDefaultActivityDependency,
            lead_times_default_check_in_frequency: this.leadTimesDefaultCheckInFrequency,
            lead_times_default_lead_time: this.leadTimesDefaultLeadTime,
            lead_times_default_lead_time_unit_type: this.leadTimesDefaultLeadTimeUnitType,
            lead_times_default_order_delay_unit_type: this.leadTimesDefaultOrderDelayUnitType,
            lead_times_default_review_cycle_modifier: this.leadTimesDefaultReviewCycleModifier,
            lead_times_default_review_duration_unit_type: this.leadTimesDefaultReviewDurationUnitType,
            lead_times_default_shakeout_days: this.leadTimesDefaultShakeoutDays,
            lead_times_order_delay: this.leadTimesOrderDelay,
            lead_times_required_on_jobsite_require_gc: this.leadTimesRequiredOnJobsiteRequireGc,
            lead_times_review_duration: this.leadTimesReviewDuration,
            lead_times_revise_and_resubmit_responses: this.leadTimesReviseAndResubmitResponses,
            lead_times_submit_responses: this.leadTimesSubmitResponses,
            lead_times_valid_approve_statuses: this.leadTimesValidApproveStatuses,
            lead_times_valid_revise_and_resubmit_statuses: this.leadTimesValidReviseAndResubmitStatuses,
            lead_times_valid_submit_statuses: this.leadTimesValidSubmitStatuses,
            lightning_alert_distance: this.lightningAlertDistance,
            lightning_alerts_channel: this.lightningAlertsChannel,
            lightning_all_clear: this.lightningAllClear,
            lightning_all_clear_duration: this.lightningAllClearDuration,
            listed: this.listed,
            lon: this.lon,
            lon_override: this.lonOverride,
            map_lat: this.mapLat,
            map_lon: this.mapLon,
            map_style: this.mapStyle,
            map_zoom: this.mapZoom,
            max_delivery_schedule: this.maxDeliverySchedule,
            min_delivery_schedule: this.minDeliverySchedule,
            notification_lists_areas: this.notificationListsAreas,
            notification_lists_equipments: this.notificationListsEquipments,
            notification_lists_teams: this.notificationListsTeams,
            overview_email_day: this.overviewEmailDay,
            overview_email_time: this.overviewEmailTime,
            owning_team_id: this.owningTeamId,
            ppe_required: this.ppeRequired,
            procurement_sync_time: this.procurementSyncTime,
            project_has_been_modified: this.projectHasBeenModified,
            project_name: this.projectName,
            require_vendor_address: this.requireVendorAddress,
            require_vendor_info_deliveries: this.requireVendorInfoDeliveries,
            share_delivery_vehicle: this.shareDeliveryVehicle,
            share_eta: this.shareEta,
            state: this.state,
            submittal_statistics: this.submittalStatistics,
            submittals_integration_source: this.submittalsIntegrationSource,
            timezone: this.timezone,
            unique_token: this.uniqueToken,
            updated_at: this.updatedAt,
            use_advanced_delivery_logic: this.useAdvancedDeliveryLogic,
            use_advanced_delivery_logic_equipment: this.useAdvancedDeliveryLogicEquipment,
            use_advanced_delivery_logic_exception_days: this.useAdvancedDeliveryLogicExceptionDays,
            use_advanced_delivery_logic_map_marker: this.useAdvancedDeliveryLogicMapMarker,
            use_advanced_delivery_logic_pending: this.useAdvancedDeliveryLogicPending,
            use_advanced_delivery_logic_teams: this.useAdvancedDeliveryLogicTeams,
            use_deliveries: this.useDeliveries,
            use_lead_times: this.useLeadTimes,
            use_override: this.useOverride,
            weather_provider: this.weatherProvider,
            weather_provider_config: this.weatherProviderConfig,
            weather_severe_channel: this.weatherSevereChannel,
            weather_threats_channel: this.weatherThreatsChannel,
            work_event_approval_require_final: this.workEventApprovalRequireFinal,
            zip_code: this.zipCode,
            activities: this.activities?.map((item) => item.toApiObject()),
            activity_api_async_imports: this.activityApiAsyncImports?.map((item) => item.toApiObject()),
            api_keys: this.apiKeys?.map((item) => item.toApiObject()),
            areas: this.areas?.map((item) => item.toApiObject()),
            audits: this.audits?.map((item) => item.toApiObject()),
            calendar_event_resources_attributes: this.calendarEventResources?.map((item) => item.toApiObject()),
            calendar_events: this.calendarEvents?.map((item) => item.toApiObject()),
            command_center_views: this.commandCenterViews?.map((item) => item.toApiObject()),
            deliveries_attributes: this.deliveries?.map((item) => item.toApiObject()),
            delivery_filters: this.deliveryFilters?.map((item) => item.toApiObject()),
            equipment_attributes: this.equipment?.map((item) => item.toApiObject()),
            executive_command_sections: this.executiveCommandSections?.map((item) => item.toApiObject()),
            map_layers: this.mapLayers?.map((item) => item.toApiObject()),
            map_objects: this.mapObjects?.map((item) => item.toApiObject()),
            materials_attributes: this.materials?.map((item) => item.toApiObject()),
            messages: this.messages?.map((item) => item.toApiObject()),
            notification_lists: this.notificationLists?.map((item) => item.toApiObject()),
            order_exports: this.orderExports?.map((item) => item.toApiObject()),
            orders_attributes: this.orders?.map((item) => item.toApiObject()),
            permissions: this.permissions?.map((item) => item.toApiObject()),
            procurement_filters: this.procurementFilters?.map((item) => item.toApiObject()),
            procurement_views: this.procurementViews?.map((item) => item.toApiObject()),
            projects_weather_alerts: this.projectsWeatherAlerts?.map((item) => item.toApiObject()),
            recipient_lists: this.recipientLists?.map((item) => item.toApiObject()),
            repeating_calendar_event_definitions_attributes: this.repeatingCalendarEventDefinitions?.map((item) =>
                item.toApiObject()
            ),
            scheduled_reports: this.scheduledReports?.map((item) => item.toApiObject()),
            submittals: this.submittals?.map((item) => item.toApiObject()),
            values_attributes: this.values?.map((item) => item.toApiObject()),
            vendor_links: this.vendorLinks?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Project {
        const clone = Object.create(this) as Project;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
